const NotFound = () => {
    return (
      <div>
        <h1>404 - Path Not Found - This is not the right health journey</h1>
      </div>
    );
  };
  
  export default NotFound;